import React from "react"
import AppCtaBanner from "./index"
import Theme from "@airasia/phoenix-components/components/Theme"


const en_gb = {
  title: "Download the best travel and lifestyle app here",
  description:
    "Go further. Be more adventurous. A world of opportunities awaits within the AirAsia MOVE mobile app!",
}

const ms_my = {
  title: "Muat turun aplikasi perjalanan dan gaya hidup terbaik di sini",
  description:
    "Pergi lebih jauh. Bertualang lebih berani. Sebuah dunia penuh peluang menunggu dalam aplikasi seluler AirAsia MOVE!",
}

const ru_ru = {
  title: "Скачайте лучшее приложение для путешествий и образа жизни здесь",
  description:
    "Отправляйтесь дальше. Будьте более авантюрными. Мир возможностей ждет вас в мобильном приложении AirAsia MOVE!",
}

const km_kh = {
  title: "ទាញយកកម្មវិធីដែលល្អបំផុតនៅទីនេះ",
  description:
    "ធ្វើដំណើរបន្តបន្តបំផុត។ ជួយដល់ការវិភាគច្រើនជាងមុនក្នុងកម្មវិធីទូរស័ព្ទ AirAsia MOVE!",
}

const vi_vn = {
  title: "Tải xuống ứng dụng du lịch và lối sống tốt nhất tại đây",
  description:
    "Đi xa hơn. Mạo hiểm hơn. Một thế giới của cơ hội đang chờ đợi trong ứng dụng di động AirAsia MOVE!",
}

const tr_tr = {
  title: "En iyi seyahat ve yaşam tarzı uygulamasını buradan indirin",
  description:
    "Daha ileri gidin. Daha cesur olun. AirAsia MOVE mobil uygulaması içinde bir dünya fırsat sizi bekliyor!",
}

const id_id = {
  title: "Unduh aplikasi perjalanan dan gaya hidup terbaik di sini",
  description:
    "Pergi lebih jauh. Bertualang lebih berani. Sebuah dunia penuh peluang menunggu dalam aplikasi seluler AirAsia MOVE!",
}

const th_th = {
  title: "ดาวน์โหลดแอพท่องเที่ยวและแพลตฟอร์มไลฟ์สไตล์ที่ดีที่สุดได้ที่นี่",
  description:
    "ไปได้ไกลกว่าเดิม สัมผัสความตื่นเต้นที่มากขึ้น โลกแห่งโอกาสรอคุณอยู่ที่ AirAsia MOVE โมบายแอพ",
}

const ko_kr = {
  title: "여기에서 최고의 여행 및 라이프스타일 앱을 다운로드하세요.",
  description:
    "더 많이 여행해보세요. 모험심을 더 가져보세요. AirAsia MOVE 모바일 앱에서 다양한 기회들이 기다리고 있습니다!",
}

const zh_hk = {
  title: "在此處下載最佳旅行及生活應用程式",
  description:
    "走遠一點。更大膽一點。大量機會盡在 AirAsia MOVE 流動應用程式等您！",
}

const zh_cn = {
  title: "点击此处下载最好的旅游和生活方式应用程序",
  description:
    "继续前行！多点冒险精神！通过AirAsia MOVE移动应用程序探索这个充满机会的世界！",
}

const zh_tw = {
  title: "在此處下載最佳的旅遊和生活應用程式",
  description:
    "走遠一點。更大膽一點。滿滿的機會就在 AirAsia MOVE 行動應用程式內等著您！",
}

const ja_jp = {
  title: "最高の旅行＆ライフスタイルアプリのダウンロードはこちら",
  description:
    "もっと先へ。もっと冒険しよう。AirAsia MOVE モバイルアプリでは、そのチャンスがあなたを待っています！",
}

const propsByLocale = {
  "en-gb": en_gb,
  "ms-my": ms_my,
  "ru-ru": ru_ru,
  "km-kh": km_kh,
  "vi-vn": vi_vn,
  "tr-tr": tr_tr,
  "id-id": id_id,
  "th-th": th_th,
  "ko-kr": ko_kr,
  "zh-hk": zh_hk,
  "zh-cn": zh_cn,
  "zh-tw": zh_tw,
  "ja-jp": ja_jp,
}

export const AppCtaDesktopWrapper = {
  "/": <AppCtaBanner {...en_gb} />,
  "/id/id": <AppCtaBanner {...id_id} />,
  "/th/th": <AppCtaBanner {...th_th} />,
  "/ja/jp": <AppCtaBanner {...ja_jp} />,
  "/ko/kr": <AppCtaBanner {...ko_kr} />,
  "/zh/tw": <AppCtaBanner {...zh_tw} />,
  "/zh/hk": <AppCtaBanner {...zh_hk} />,
  "/zh/cn": <AppCtaBanner {...zh_cn} />,
}

export const AppCtaMobileWrapper = {
  "/": <AppCtaBanner {...en_gb} isMobile={true} />,
  "/id/id": <AppCtaBanner {...id_id} isMobile={true} />,
  "/th/th": <AppCtaBanner {...th_th} isMobile={true} />,
  "/ja/jp": <AppCtaBanner {...ja_jp} isMobile={true} />,
  "/ko/kr": <AppCtaBanner {...ko_kr} isMobile={true} />,
  "/zh/tw": <AppCtaBanner {...zh_tw} isMobile={true} />,
  "/zh/hk": <AppCtaBanner {...zh_hk} isMobile={true} />,
  "/zh/cn": <AppCtaBanner {...zh_cn} isMobile={true} />,
}


export const AppCtaWrapper = ({lang="en-gb", isMobile=false}) => <Theme theme='AIRASIA_MOVE'><AppCtaBanner {...propsByLocale[lang]} isMobile={isMobile} /></Theme>